import { PositionAssignmentReport } from '@src/main/modules/reports/shared/domain/report.interface';
import { TFunction } from 'i18next';
import { Button } from 'primereact/button';
import { useCallback } from 'react';

export const usePositionAssignmentColumnBodies = (
  t: TFunction,
  downloadPdf: (evaluation: PositionAssignmentReport) => void,
) => {
  const pdfColumnBody = useCallback(
    (rowData: PositionAssignmentReport) => (
      <Button
        icon="pi pi-paperclip"
        className="p-button-text"
        tooltip={t('common.download')}
        onClick={() => downloadPdf(rowData)}
        pt={{ icon: { style: { color: 'var(--primary-color)' } } }}
      />
    ),
    [downloadPdf, t],
  );

  return pdfColumnBody;
};
